import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { RadarStatus } from '../../gql/graphql'

const NEXT_STATUS: Partial<Record<RadarStatus, { id: RadarStatus; label: string }>> = {
  [RadarStatus.New]: { id: RadarStatus.InProgress, label: 'Folyamatban' },
  [RadarStatus.InProgress]: { id: RadarStatus.Done, label: 'Készen van' },
  [RadarStatus.Problems]: { id: RadarStatus.InProgress, label: 'Folyamatban' },
  [RadarStatus.Done]: { id: RadarStatus.Approved, label: 'Jóváhagyva' },
}

type Props = {
  status: RadarStatus | null
  onChange: (status: RadarStatus) => void
}

const NextStatusButton = ({ status, onChange }: Props) => {
  if (!status) return null

  const next = NEXT_STATUS[status]
  if (!next) return null

  return (
    <Button size="sm" variant="outline" onClick={() => onChange(next.id)}>
      <ArrowRight className="h-3 w-3" />
      {next.label}
    </Button>
  )
}

export default NextStatusButton
